// extracted by mini-css-extract-plugin
export default {"container":"cC-z","modal":"dC-z","dimensions":"eC-z","brandName":"fC-z","productName":"gC-z","labelValue":"hC-z","recipientEmail":"iC-z","recommendedFit":"jC-z","hiddenField":"kC-z"};